<svelte:head>
  <title>Premium Access | A Good Thing</title>
</svelte:head>


{#if hasActiveSubscription(company)}


<div class="block has-text-weight-bold">
  Premium Access is enabled on your account until
  {dayjs(company.subscriptions.current.expiryDate).format('DD MMMM YYYY')}
  ({subscriptionDaysRemaining(company)} days remaining).
  {#if subscriptionDaysRemaining(company) < 7}
  <a
  target="_blank"
  href="https://www.agoodthing.org.uk/business-pricing">Extend subscription</a>
  {/if}
</div>


<div class="block">
  Thank you for supporting A Good Thing!  
</div>


{:else}

<div class="block">
  Premium Access is required for large or high-value offers. It allows you to make unlimited offers during a 1-month period. <a target="_blank" href="https://www.agoodthing.org.uk/business-pricing">Learn more</a>.
</div>

{#if company?.subscriptions?.current?.expiryDate}
  <div class="block">
    <strong>Your subscription expired on {dayjs(company.subscriptions.current.expiryDate).format('DD MMMM YYYY')}.</strong>
  </div>
{/if}

<div class="block">
<a
  class="button is-primary"
  target="_blank"
  href="https://www.agoodthing.org.uk/business-pricing">Buy Premium Access</a
>
</div>
{/if}

<script lang="ts">
  import { appState } from "../../../lib/appState";
  import dayjs from "dayjs";
  import { hasActiveSubscription, subscriptionDaysRemaining } from '../../../lib/subscriptionHelper';

  let company = $appState.company as Company_v1;
</script>